import API from "../utility/axios";
const apiUrl = "/api/v2";
export const USERS_ACCOUNT_TYPE = (data: any): Promise<any> => {
  return API.post(`${apiUrl}/bulk/update/user/account/types`, data);
};
